// extracted by mini-css-extract-plugin
export var container = "_52-0";
export var containerTopRight = "_52-1";